module.exports = __webpack_public_path__ + "static/mobile-incentivized-traffic-a32ab2d3b5423e87e1eb2fd6f176fa8b.gif";